import router from '../router/router';

const mutations = {
    // 错误信息统一处理
    handleErrorMessage(state, errorMessage) {
        console.error(errorMessage);
        state.errorMessage = errorMessage;
        setTimeout(() => {
            state.errorMessage = '';
        }, 1000);
    },
    // 成功消息提醒
    handleSuccessMessage(state, successMessage) {
        state.successMessage = successMessage;
        setTimeout(() => {
            state.successMessage = '';
        }, 1000);
    },
    //setAllCourse
    setAllCourse(state, value) {
        state.courseList = value;
    },
    setCourse(state, value) {
        state.course = value;
    },
    setMyCourse(state, value) {
        state.myCourse = value;
    },
    setMineCourse(state, value) {
        state.mineCourse = value;
    },
    setSchoolSiteVersion(state, version) {
      state.schoolVersion = version;
    },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/mutations/school.js